import { createFileRoute } from '@tanstack/react-router';
import { ReportsPage } from '@/domains/credit';

// Ruta estática: gana sobre la dinámica hermana `$section` (que sigue cubriendo el resto).
export const Route = createFileRoute('/_backoffice/credit/reports')({
    component: CreditReports,
});

function CreditReports() {
    return <ReportsPage />;
}
